<template>
  <div>
    <div v-if="!isPageContextSpace" id="stickyline"></div>
    <div v-else v-sticky="{ zIndex: 100, stickyTop: 0 }" class="sticky">
      <div id="stickyline">
        <VSkipTo :text="$t('common.skip_to')" />
        <transition name="slide" mode="out-in" appear>
          <VDashboard v-if="isDashboardVisible" />
        </transition>
        <transition name="slide" mode="out-in" appear>
          <VNavigation :is-navigation-flat="isNavigationFlat" :items="navigationItems" />
        </transition>
      </div>
    </div>

    <main id="main" tabindex="-1">
      <VBreadcrumb :is-navigation-flat="isNavigationFlat" />
      <VBanner />
      <slot :is-navigation-flat="isNavigationFlat" />
    </main>

    <VFooter />

    <VueGlobalEvents @mousedown="onStorePreviousFocus" @keydown.tab="onStorePreviousFocus" />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import sticky from 'vue-sticky';
import VSkipTo from '@/components/UI/SkipTo';
import VBanner from '@/components/UI/Banner';
import { getVisibleNavigationItems } from '@/utils/navigation';

export default {
  name: 'LayoutDefault',

  directives: {
    sticky,
  },

  components: {
    VSkipTo,
    VBanner,
    VFooter: () => import('@/components/UI/Footer'),
    VNavigation: () => import('@/components/UI/Navigation'),
    VBreadcrumb: () => import('@/components/UI/Breadcrumb'),
    VDashboard: () => import('@/components/UI/Dashboard'),
    VueGlobalEvents: () => import('vue-global-events'),
  },

  computed: {
    navigationItems() {
      return getVisibleNavigationItems(this.$store);
    },

    isNavigationFlat() {
      return this.navigationItems.length <= this.flatLinkLimit;
    },

    ...mapGetters('system', ['isDashboardVisible', 'isPageContextSpace']),

    ...mapState('system', ['initPromise', 'flatLinkLimit']),
  },

  methods: {
    /**
     * Store the previously focused element to be able to restore the focus after
     * closing an dialogue or leaving vue-focus-trap
     */
    onStorePreviousFocus() {
      document.previousElement = document.activeElement;
    },
  },
};
</script>
